import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./formattedRichText.html";
function sanitizeHtml(str) {
  const allowedTags = ['a', 'b', 'em', 'br', 'strong', 'ol', 'ul', 'li', 'p', 'h2', 'h3', 'h4', 'h5', 'h6'];
  const pattern = new RegExp(`<(/?(?!${allowedTags.join('|')})\\b[^>]*?)>`, 'gi');
  return str.replace(pattern, '');
}
class FormattedRichText extends LightningElement {
  constructor(...args) {
    super(...args);
    this.value = void 0;
  }
  get sanitizedValue() {
    return sanitizeHtml(this.value);
  }
  renderedCallback() {
    const containerEl = this.template?.querySelector('.container');
    if (containerEl) {
      containerEl.innerHTML = this.sanitizedValue;
    }
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(FormattedRichText, {
  publicProps: {
    value: {
      config: 0
    }
  }
});
const __lwc_component_class_internal = _registerComponent(FormattedRichText, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;